module.exports = __webpack_public_path__ + "static/media/in-app.ee71425e.svg";